<div [ngStyle]="{ width: '100vw' }" class="u-paddingBottom-40">
  <ng-container *ngIf="!config?.hasFixedHeader">
    <div
      *ngIf="!config?.hideClose"
      [ngStyle]="{
        'min-height': '80px',
        'background-color': config.backgroundColor
      }"
      [ngStyle.gt-xs]="{
        height: '150px',
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0'
      }"
      class="bg-color-blue"
    >
      <div [ngClass.gt-xs]="'u-padding-16'">
        <button mat-icon-button (click)="close()">
          <i class="material-icons color-white">close</i>
        </button>
      </div>
    </div>
    <div
      [ngStyle]="{
        transform: 'translateY(-50px)',
        width: '80vw',
        'max-width': '700px',
        'padding-bottom': '80px'
      }"
      [ngStyle.gt-xs]="{ transform: 'translateY(80px)' }"
      class="u-margin-center"
    >
      <div class="mat-elevation-z1 bg-color-white">
        <ng-container [cdkPortalOutlet]="childPortal"></ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="config?.hasFixedHeader">
    <div
      *ngIf="!config?.hideClose"
      [ngStyle]="{
        position: 'fixed',
        top: '8px',
        left: '8px',
        'z-index': '10'
      }"
    >
      <button mat-icon-button (click)="close()">
        <i class="material-icons color-white">close</i>
      </button>
    </div>
    <div
      [ngStyle]="{
        position: 'fixed',
        height: '180px',
        width: '100vw',
        top: 0,
        left: 0,
        right: 0,
        'z-index': '5',
        'background-color': config.backgroundColor
      }"
      class="bg-color-blue"
    ></div>
    <ng-container [cdkPortalOutlet]="childPortal"></ng-container>
  </ng-container>
</div>
